export default __webpack_public_path__ + "static/media/NEAR.43745a50.svg";